<template>
  <p>
    {{ activeCarrierMarkets }}
  </p>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import { useGetWeekday } from '../../../../composables/useGetWeekday'

import translations from './ActiveCarrierMarkets.translations'
import type { ActiveCarrierMarketsProps } from './ActiveCarrierMarkets.types'

const i18n = useI18n()

const getWeekday = useGetWeekday()

const { weekendDeliveryConfigurations } =
  defineProps<ActiveCarrierMarketsProps>()

const saturdayActiveCarrierMarkets = computed(() => {
  return (
    weekendDeliveryConfigurations.filter(
      ({ day, workingDay }) => day === 'SATURDAY' && workingDay,
    ).length || 0
  )
})

const sundayActiveCarrierMarkets = computed(() => {
  return (
    weekendDeliveryConfigurations.filter(
      ({ day, workingDay }) => day === 'SUNDAY' && workingDay,
    ).length || 0
  )
})

const activeCarrierMarkets = computed(() => {
  return i18n(translations.activeCarrierMarketsWeekend, {
    saturday: i18n(translations.activeCarrierMarketsWeekendDay, {
      weekday: getWeekday('SATURDAY'),
      activeMarkets: saturdayActiveCarrierMarkets.value,
    }),
    sunday: i18n(translations.activeCarrierMarketsWeekendDay, {
      weekday: getWeekday('SUNDAY'),
      activeMarkets: sundayActiveCarrierMarkets.value,
    }),
  })
})
</script>
